export default __webpack_public_path__ + "static/media/IMG-20240708-WA0014.8f2ab92d.jpg";